/**
 * SPA-routed link to another Beacon page, for id columns and cross-references.
 * Appends the region here so no caller can drop it.
 *
 *   <DetailLink to={`/artifact?id=${encodeURIComponent(id)}`}>{id}</DetailLink>
 */
import { ReactNode } from 'react';
import Link from '@cloudscape-design/components/link';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/store/hooks';
import { withRegion } from 'src/constants';

export const DetailLink = ({ to, children }: { to: string; children: ReactNode }) => {
  const navigate = useNavigate();
  const region = useAppSelector((state) => state.env.region);
  const target = withRegion(to, region);
  return (
    <Link href={target} onFollow={(e) => { e.preventDefault(); navigate(target); }}>
      {children}
    </Link>
  );
};
